module.exports = __webpack_public_path__ + "static/me-11fd9f5754737a5278200089fc49238a.png";